"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { DollarSign, TrendingUp, Users, Zap } from "lucide-react";
export default function MonetizationHighlights() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="monetization-highlights" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div className="relative group">
            <div className="aspect-video rounded-lg overflow-hidden bg-surface shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1533057/img/monetization_video_player_mockup.png" alt="Monetization video player interface" className="w-full h-full object-cover" />
              {}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer" />
            </div>
            {}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="size-16 rounded-full bg-primary/90 flex items-center justify-center shadow-strong group-hover:scale-110 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                <div className="w-0 h-0 border-t-8 border-t-transparent border-l-12 border-l-foreground-primary border-b-8 border-b-transparent ml-1" />
              </div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <div className="space-y-3">
              <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground">
                Turn Your Content Into Revenue
              </h2>
              <p className="text-lg text-muted-foreground">ViddTube's built-in monetization features help you earn from every view with seamless ad integration and creator-friendly tools.</p>
            </div>

            {}
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                  <DollarSign className="size-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Direct Revenue Generation
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Earn money directly from your audience through seamless ad
                    placements.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="size-10 rounded-md bg-secondary/10 flex items-center justify-center shrink-0 mt-0.5">
                  <TrendingUp className="size-5 text-secondary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Real-Time Analytics
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Track your earnings and performance with detailed insights
                    and metrics.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="size-10 rounded-md bg-accent/10 flex items-center justify-center shrink-0 mt-0.5">
                  <Users className="size-5 text-accent" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Viewer-Friendly Experience
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Non-intrusive ads that maintain high-quality viewing
                    experience.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                  <Zap className="size-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Instant Setup
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Enable monetization in minutes with our streamlined
                    onboarding process.
                  </p>
                </div>
              </li>
            </ul>

            {}
            <div className="pt-2">
              <Button asChild size="lg" className="btn-primary">
                <Link to="#" newTab>
                  Learn More
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        .animate-shimmer {
          animation: shimmer 2s linear infinite;
        }
      `}</style>
    </section>;
}